import { jsx } from "react/jsx-runtime";
import "@tamagui/polyfill-dev";
import { isWeb, useIsomorphicLayoutEffect } from "@tamagui/core";
import { YStack } from "@tamagui/stacks";
import * as React from "react";
import { createPortal } from "react-dom";
const Portal = React.memo(
  ({ host = ((_a) => (_a = globalThis.document) == null ? void 0 : _a.body)(), ...props }) => {
    const contents = /* @__PURE__ */ jsx(
      YStack,
      {
        contain: "strict",
        fullscreen: true,
        position: isWeb ? "fixed" : "absolute",
        maxWidth: isWeb ? "100vw" : "100%",
        maxHeight: isWeb ? "100vh" : "100%",
        pointerEvents: "none",
        ...props
      }
    );
    const [hostElement, setHostElement] = React.useState(null);
    useIsomorphicLayoutEffect(() => {
      setHostElement(host);
    }, [host]);
    if (hostElement && props.children) {
      return createPortal(contents, hostElement);
    }
    return null;
  }
);
export {
  Portal
};
//# sourceMappingURL=Portal.js.map
